<template>
  <div  style="position:relative">
    <div id="show-table">
      <table class="table table-hover table-show" :class="{minheight: isActive}">
        <caption id="table-title">
          <ul class="list-basic-settings">
            <li
              v-for="(item,index) in captionTitle"
              @click="toggle(index)"
              :class="{nativeLi: active == index}"
              :key="item + index"
            >
              {{ item
              }}
              <!-- <div v-if></div> -->
            </li>
            <li id="time-li">
              <!-- <select name id>
                <option value>发布时间</option>
              </select> -->
            </li>
          </ul>
        </caption>
        <tbody>
          <template v-if=" infos != '' ">
            <tr v-for="info in infos" class="tr-height" @click="seeDetails(info)">
              <template v-if=" dataType==='招标公告' || dataType==='询价公告'">
                <template v-if="info.timeStatus">
                  <td width="13%">
                    <template v-if=" info.timeStatus==='1' ">
                      <span class="state state-bid">未开始</span>
                    </template>
                    <template v-else-if=" info.timeStatus==='3' ">
                      <span class="state state-enquiry">已结束</span>
                    </template>
                    <template v-else-if=" info.timeStatus==='2' ">
                      <span class="state state-bidding">进行中</span>
                    </template>
                  </td>
                </template>
                <template v-else>
                  <td width="13%">
                    <template v-if=" now < timeFormat(info.publishTime) ">
                      <span class="state state-bid">未开始</span>
                    </template>
                    <template v-else-if=" now > timeFormat(info.deadline) ">
                      <span class="state state-enquiry">已结束</span>
                    </template>
                    <template v-else>
                      <span class="state state-bidding">进行中</span>
                    </template>
                  </td>
                </template>
                <td class="limitText" :title="info.messageTitle" width="20%">
                  <div>{{info.messageTitle}}</div>
                </td>
                <td width="15%">{{info.purOrgName}}</td>
                <td class="limitText" :title="info.messageContent" width="22%">
                  <div>{{info.messageContent}}</div>
                </td>
                <td class="limitText" :title="info.billcode" width="15%">
                  <div>{{info.billcode}}</div>
                </td>
                <td width="15%">
                  <span class="pull-right">
                    截止时间：
                    <br>
                    {{info.deadline | cutStr}}
                  </span>
                </td>
              </template>
              <template v-else-if=" dataType==='中标公告' ">
                <td width="20%" class="limitText limitContent2" :title="info.messageTitle">
                  <div>{{info.messageTitle}}</div>
                </td>
                <td width="20%" class="limitText limitContent2" :title="info.purOrgName">{{info.purOrgName}}</td>
                <td width="20%" class="limitText limitContent2" :title="info.messageContent">{{info.messageContent}}</td>
                <td width="20%" class="limitText limitContent2" :title="info.billcode">{{info.billcode}}</td>
                <td width="20%">
                  <span class="pull-right">
                    发布时间：
                    <br>
                    {{info.publishTime | cutStr}}
                  </span>
                </td>
              </template>
            </tr>
          </template>
          <template v-else>
            <p class="error-handling">暂无数据</p>
          </template>
        </tbody>
      </table>
    </div>
    <select name id class="select-by-state" v-show="isSelectByStateShow" v-model="stateSelected" @change="selectState($event)" >
        <option value>全部</option> 
        <option value=1>未开始</option>
        <option value=2>进行中</option>
        <option value=3>已结束</option>
    </select>
    <div id="paging" class="pull-right" v-show="isActive == false">
      <nav>
        <ul class="pagination">
          <li :class="{disabled: disabled[0]}" @click="pageUp()">
            <a href="javascript:;">&laquo;</a>
          </li>
          <!--<li v-for="n in pagesNum" @click="turnPage(n)"><a-->
          <!--href="javascript:;" :class="{currentPage: currentPage == n}">{{ n }}</a>-->
          <!--</li>-->
          <li v-for="(item,index) in pagingContent">
            <template v-if="item">
              <span
                v-html="item"
                :class="{currentPage: currentPage == index+1}"
                @click="turnPage(index+1,item)"
              ></span>
            </template>
          </li>
          <li :class="{disabled: disabled[1]}" @click="pageDown()">
            <a href="javascript:;">&raquo;</a>
          </li>
        </ul>
      </nav>
      <p>
        共{{ pagesNum }}页 &nbsp;&nbsp;到第
        <input id="pagesNum" class="whichPage" type="number" :max="pagesNum"> 页
        <button id="turnPage" @click="btnTurnPage()">确定</button>
      </p>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
import { apiLinks } from '../api/links.js'
import Bus from '../eventbus/bus'
import EVENTLIST from '../eventbus/eventlist'

export default {
  name: 'showtable',
  props: {
    captionTitle: '',
    condition: '',
    dataUrl: ''
  },
  data () {
    return {
      //        tab选项卡的展示内容index
      active: 1,
      //        得到的数据
      infos: '',
      url: '',
      isActive: true,
      //        数据总页数
      pagesNum: '',
      //        当前页
      currentPage: 1,
      //        当前页面的url
      currentPageUrl: this.dataUrl[1],
      record: this.dataUrl[1],
      disabled: [
        true,
        false
      ],
      dataType: '招标公告',
      now: new Date().getTime(),
      pagingContent: [],
      //按状态选择显示
      stateSelected: '',
      isSelectByStateShow: true,
      currentTimeStatus: '',
      currentKey0: '',
      currentKey1: '',
      currentKey2: '',
      currentKey3: ''
    }
  },
  created: function () {
    // 根据传值判断是哪个页面的table数据
    let array = window.location.href.split('?')
    if (array.length > 1) {
      let index = parseInt(array[1].split('=')[1])
      switch (index) {
        case 0:
          this.dataType = '询价公告'
          break
        case 1:
          this.dataType = '招标公告'
          break
        case 2:
          this.dataType = '中标公告'
          break
        default:
          this.dataType = ''
          break
      }
      this.active = index
      this.currentPageUrl = this.dataUrl[index]
    }
    if (this.currentPageUrl !== '') {
      this.getCustomers(this.currentPageUrl)
    }
    Bus.$on("ORGDATA_SEARCH", (key0,key1,key2,key3) => {
      var condition = this.condition
      this.currentKey0 = key0 ? key0 : ''
      this.currentKey1 = key1 ? key1 : ''
      this.currentKey2 = key2 ? key2 : ''
      this.currentKey3 = key3 ? key3 : ''
      this.currentPageUrl = this.currentPageUrl.split('&purOrgName')[0] + '&purOrgName=' + key0 + '&messageTitle=' + key1 + '&messageContent=' + key2 + '&billcode=' + key3 + '&timeStatus=' + this.currentTimeStatus + '&innercode=' + condition
      this.getCustomers(this.currentPageUrl)
    })
  },
  filters: {
    cutStr: function (str) {
      if (!str) return ''
      let abortDate = ''
      abortDate = str.split('-')
      let abortDay = ''
      abortDay = abortDate[abortDate.length - 1].split(' ')
      return abortDate[0] + '年' + abortDate[1] + '月' + abortDay[0] + '日'
    },
    timeNum: function (str) {
      //          v-if里面不能使用过滤器？没有用到这个过滤器
      if (!str) return ''
      return new Date(str).getTime()
      //        let t = Date.parse(str)
      //        if (!isNaN(t)) {
      //          return new Date(Date.parse(str.replace(/-/g, '/'))).getTime()
      //        } else {
      //          return ''
      //        }
    }
  },

  methods: {
    nowUrl: function () {
      this.url = window.location.href
    },
    toggle: function (index) {
      //按状态选择清除
      this.stateSelected= ''

      this.currentKey0 = ''
      this.currentKey1 = ''
      this.currentKey2 = ''
      this.currentKey3 = ''
      this.$parent.searchKeyword0 = ''
      this.$parent.searchKeyword1 = ''
      this.$parent.searchKeyword2 = ''
      this.$parent.searchKeyword3 = ''
      this.currentTimeStatus= ''
      //        index = parseInt(index)
      this.currentPage = 1
      //        if (index === 1) {
      //          this.dataType = '招标公告'
      //        } else if (index === 2) {
      //          this.dataType = '中标公告'
      //        } else {
      //          this.dataType = ''
      //        }
      switch (index) {
        case 0:
          this.dataType = '询价公告'
          this.isSelectByStateShow = true
          break
        case 1:
          this.dataType = '招标公告'
          this.isSelectByStateShow = true
          break
        case 2:
          this.dataType = '中标公告'
          this.isSelectByStateShow = false
          break
        default:
          this.dataType = ''
          break
      }
      this.currentPageUrl = this.dataUrl[index]
      this.record = this.dataUrl[index]
      this.active = index
      if (this.dataUrl[index] !== '') {
        var condition = this.condition
        this.getCustomers(this.currentPageUrl + '&innercode=' + condition + '&timeStatus=' + this.currentTimeStatus + '&purOrgName=' + this.currentKey0 + '&messageTitle=' + this.currentKey1 + '&messageContent=' + this.currentKey2 + '&billcode=' + this.currentKey3)
      } else {
        this.isActive = true
        this.infos = ''
      }
      //        this.$emit('toggle')
      Bus.$emit('todo_change')
      // Bus.$emit(EVENTLIST.TODO_CHANGE)
    },
    getCustomers: function (url) {
      this.$http.jsonp(url, []).then(function (response) {
        if (response.data[0]['result'].length) {
          this.infos = response.data[0]['result']
          this.pagesNum = response.data[0].totalPage
          //            this.pagesNum = 50
          this.pagingConstruct(this.currentPage)
        } else {
          this.infos = ''
          this.isActive = true
        }
        if (this.infos !== '') {
          this.isActive = false
        }
        if (this.currentPage < 1 || this.currentPage === 1) {
          this.disabled[0] = true
        } else {
          this.disabled[0] = false
        }
        if (this.currentPage > this.pagesNum || this.currentPage === this.pagesNum) {
          this.disabled[1] = true
        } else {
          this.disabled[1] = false
        }
      }, function (response) { })
    },
    judgeCurrentPage: function (index) {
      let str = this.currentPageUrl
      let array = str.split('pageIndex=')
      let orgName = str.split('purOrgName=')
      if (orgName[1]) {
        str = array[0] + 'pageIndex=' + (index - 1) + '&purOrgName=' + orgName[1]
      } else {
        str = array[0] + 'pageIndex=' + (index - 1)
      }
      this.currentPageUrl = str
      this.getCustomers(this.currentPageUrl + '&innercode=' + this.condition + '&timeStatus=' + this.currentTimeStatus + '&purOrgName=' + this.currentKey0 + '&messageTitle=' + this.currentKey1 + '&messageContent=' + this.currentKey2 + '&billcode=' + this.currentKey3)      
    },
    btnTurnPage: function () {
      let value = parseInt(document.getElementById('pagesNum').value)
      if (value > this.pagesNum) {

      } else if (value < 1) {

      } else {
        this.currentPage = value
        this.judgeCurrentPage(this.currentPage)
      }
      document.getElementById('pagesNum').value = ''
    },
    turnPage: function (index, item) {
      if (item.length > 30) {
        this.currentPage = index
        this.judgeCurrentPage(this.currentPage)
      }
    },
    pageUp: function () {
      if (this.currentPage > 1) {
        this.currentPage--
        this.judgeCurrentPage(this.currentPage)
      }
    },
    pageDown: function () {
      if (this.currentPage < this.pagesNum) {
        this.currentPage++
        this.judgeCurrentPage(this.currentPage)
      }
    },
    seeDetails: function (info) {
      let url = ''
      var status = info.messageTypeShow
      switch (status) {
        case '1': // 招标
          url = apiLinks.details['bidDoc'] + info.msgId
          break
        case '0': // 询价
          url = apiLinks.details['inquiryDetails'] + info.msgId
          break
        case '4': // 物资招标公告
        case '6': // 物流招标公告
        case '11':// 工程招标公告
        case '12':// 服务招标公告
          if(info.bidnoticeType == 'lawnotice'){
            var params = '?endTime=' + info.deadline + '&ispur=false&purNoticeId=' + info.msgId +'&from=ztbweb'
            url = apiLinks.details['lawnotice'] + params
          } else {
            url = apiLinks.details['bidDetails'] + info.msgId
          }
          break
        case '5': // 招标中标
          url = apiLinks.details['bidMsg'] + info.msgId
          break
        case '7': // 招标中标
          url = apiLinks.details['bidMsg'] + info.msgId
          break
        case '13': // 招标中标
          url = apiLinks.details['bidMsg'] + info.msgId
          break
        case '14': // 招标中标
          url = apiLinks.details['bidMsg'] + info.msgId
          break
        case '10': // 询价中标
          url = apiLinks.details['bidMsg2'] + info.msgId
          break
        case '17': // 询价中标
        url = apiLinks.details['bidMsg3'] + info.msgId
        break
        case '21': // 询价中标
          url = apiLinks.details['biddocDetails'] + info.msgId
          break
        case '22': // 询价中标
          url = apiLinks.details['biddocDetails'] + info.msgId
          break
        case '23': // 询价中标
          url = apiLinks.details['biddocDetails'] + info.msgId
          break
        case '24': // 询价中标
          url = apiLinks.details['biddocDetails'] + info.msgId
          break
        case '26':
        case '27':
          url = apiLinks.details['supplyNotice'] + info.msgId
          break;
        default:
          url = apiLinks.details['bidNotice'] + info.msgId
          break
      }
      if (url !== '') {
        window.open(url)
      }
    },
    timeFormat: function (str) {
      if (str) {
        //      只有谷歌火狐识别'/'时间格式
        return new Date(Date.parse(str.replace(/-/g, '/'))).getTime()
      } else {
        return ''
      }
    },
    pagingConstruct: function (paging) {
      this.pagingContent = []
      //        这里是加载省略号的flag
      let isHiddenExist = 0
      //        从第1页读到第max页。
      for (let i = 1; i <= this.pagesNum; i++) {
        //          如果是页首，中间页，页尾，当前页的前后三页则不省略。
        let item
        switch (paging) {
          case 1:
            if (i < 4) {
              item = `<a href='javascript:;' title="点击进行翻页"> ${ i }</a>`
              isHiddenExist = 0
            } else {
              if (isHiddenExist === 0) {
                item = "<a href='javascript:;'>...</a>"
                isHiddenExist = 1
              }
            }
            break
          case this.pagesNum:
            if (i > (this.pagesNum - 3)) {
              item = `<a href='javascript:;' title="点击进行翻页"> ${ i }</a>`
              isHiddenExist = 0
            } else {
              if (isHiddenExist === 0) {
                item = "<a href='javascript:;'>...</a>"
                isHiddenExist = 1
              }
            }
            break
          default:
            if (i < (paging + 2) && i > (paging - 2)) {
              item = `<a href='javascript:;' title="点击进行翻页"> ${ i }</a>`
              isHiddenExist = 0
            } else {
              if (isHiddenExist === 0) {
                item = "<a href='javascript:;'>...</a>"
                isHiddenExist = 1
              }
            }
            break
        }
        //          if (i < (paging + 2) && i > (paging - 2)) {
        //            item = `<a href='javascript:;' title="点击进行翻页"> ${i}</a>`
        //            isHiddenExist = 0
        //          } else {
        //            if (isHiddenExist === 0) {
        //              item = "<a href='javascript:;'>...</a>"
        //              isHiddenExist = 1
        //            }
        //          }
        this.pagingContent.push(item)
      }
      },
    //根据状态选择
     selectState(event) {
      
      let timeStatus = event.target.value
      this.currentTimeStatus = timeStatus
      //默认是字符串类型
      this.currentPage = 1
      
      this.currentPageUrl= this.dataUrl[this.active]

       if (this.dataUrl[this.active] !== '') {
        let condition = this.condition
        this.getCustomers(this.currentPageUrl + '&innercode=' + condition + '&timeStatus=' + timeStatus + '&purOrgName=' + this.currentKey0 + '&messageTitle=' + this.currentKey1 + '&messageContent=' + this.currentKey2 + '&billcode=' + this.currentKey3)
       }
    }
  },
  watch: {
    condition: function (newQuestion) {
      if (this.condition !== '') {
        let str = this.record
        let array = str.split('?')
        //          materialClassIds=&
        str = array[0] + '?innercode=' + this.condition + '&' + array[1]
        this.currentPageUrl = str
       this.getCustomers(this.currentPageUrl + '&timeStatus=' + this.currentTimeStatus + '&purOrgName=' + this.currentKey0 + '&messageTitle=' + this.currentKey1 + '&messageContent=' + this.currentKey2 + '&billcode=' + this.currentKey3)
      } else {
        this.currentPageUrl = this.record
        this.getCustomers(this.currentPageUrl + '&timeStatus=' + this.currentTimeStatus + '&purOrgName=' + this.currentKey0 + '&messageTitle=' + this.currentKey1 + '&messageContent=' + this.currentKey2 + '&billcode=' + this.currentKey3)
      }
      this.currentPage = 1
    }
  }
}
</script>


<style lang="less">
@import "../assets/base.less";
.nativeLi {
  border-bottom: none !important;
  border-top: 3px solid @primary !important;
  /*position: relative;*/
  /*top: 1px;*/
  overflow: visible;
  position: relative;
  /*z-index: 99;*/
}

.nativeLi > div {
  /*z-index: 2;*/
  position: absolute;
  top: 37px;
  left: 0px;
  width: 98px;
  height: 3px;
  background-color: #ffffff;
}

.minheight {
  min-height: 398px;
}

.table {
  table-layout: fixed;
}

.table-show > tbody {
  border: 1px solid #dedede;
  /*border-top: none;*/
}

.error-handling {
  margin-top: 150px;
  text-align: center;
}

.state {
  display: inline-block;
  padding: 0 8px;
  /*height: 20px;*/
  text-align: center;
}

.state-bid {
  border: 1px solid #92b8e0;
  color: #639cd7;
}

.state-enquiry {
  border: 1px solid #fd9b31;
  color: #f58000;
}

.state-bidding {
  border: 1px solid #5aaef2;
  color: #5aaef2;
}

.state-other {
  border: 1px solid #cc9999;
  color: #cc9999;
}

.limitText {
  white-space: nowrap;
  /*显示省略符号来代表被修剪的文本*/
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
}

.limitText > div {
  width: 80%;
  white-space: nowrap;
  /*显示省略符号来代表被修剪的文本*/
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
}

/*  .limitContent > div {
      width: 250px;
    }*/

.tr-height {
  height: 40px;
  cursor: pointer;
  width: 100%;
}

.tr-height > td:nth-child(1) {
  padding-left: 20px;
}

.tr-height > td:last-child {
  padding-right: 20px;
}

/*翻页*/
#paging > nav {
  display: inline-block;
}

#paging > nav a {
  color: #666666;
}

#paging > p {
  display: inline-block;
  margin-left: 10px;
  position: relative;
  top: -32px;
}

#paging li > span {
  cursor: pointer;
}

.whichPage {
  border: 1px solid #ccc;
  height: 25px;
  width: 40px;
  text-align: center;
}

#turnPage {
  width: 56px;
  height: 30px;
  background-color: #f7f7f7;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  position: relative;
  top: -1px;
  color: #333333;
}

/*当前页的样式*/
.current-page {
  border: 1px solid #5aaef2;
  color: #e84c3d;
}

#time-li {
  opacity: 0;
}

.currentPage {
  background-color: #eeeeee !important;
}

.pagination > li > a:focus:first-child {
  background-color: #fff;
}

.pagination > li > a:focus:last-child {
  background-color: #fff;
}

.pagination > li > a:hover:first-child {
  background-color: #eeeeee;
}

.pagination > li > a:hover:last-child {
  background-color: #eeeeee;
}

/*.notice-content{*/

/*}*/

#show-table {
  min-height: 441px;
}

.select-by-state {
  position:absolute;
  left: 316px;
  top:0px;
  height:37px;
  width: 120px;
  padding-left: 5px;
  outline: none;
  cursor: pointer;
}
.none-select {
  color: #777;
}
</style>



// WEBPACK FOOTER //
// show-table.vue?76a5b8a3